<template>
<div :class="['editor-nav', fixed ? 'nav__white' : 'nav__transparent']" :style="setStyle(fixed)">
    <div class="editor-nav-logo" >
        <a :href="homePath">
            <slot name="logo" />
        </a>
    </div>
    <div class="editor-nav-left">
        <NavItem
            name="首页"
            :to="homePath"
            activeClass="activeClass"
            :transparent="!fixed"
            @click.native="$emit('click', { resource_title: '首页'})"/>
        <NavItem name="设计模板" :transparent="!fixed"  @click.native="$emit('click', { resource_title: '设计模板'})">
            <DesignTemplate @expose="$emit('expose', { resource_title: '设计模板'})" @click.native="e=>hanldeClick(e, { resource_title: '设计模板'})"/>
        </NavItem>
        <NavItem name="抠图换背景" :transparent="!fixed" @click.native="$emit('click', { resource_title: '抠图换背景'})">
            <Matting :uploadFunc="uploadFuncWidthLoading" @expose="$emit('expose', { resource_title: '抠图换背景'})" @click.native="e=>hanldeClick(e, { resource_title: '抠图换背景'})"/>
        </NavItem>
        <NavItem name="美化图片" :transparent="!fixed" @click.native="$emit('click', { resource_title: '美化图片'})">
            <Beautify :uploadFunc="uploadFuncWidthLoading"  @expose="$emit('expose', { resource_title: '美化图片'})" @click.native="e=>hanldeClick(e, { resource_title: '美化图片'})"/>
        </NavItem>

        <slot />
    </div>
    <div class="editor-nav-right">
        <template v-if="fixed">
            <slot name="footer">
                <div class="editor-nav-right-btn" @click="onExperience">立即体验</div>
            </slot>
        </template>
        <ToolsPopover :setIconStyle="setIconStyle"/>
        <User class="user" :session="session" />
    </div>
</div>

</template>
<script>
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Beautify from './components/beautify';
import DesignTemplate from './components/design-template';
import Matting from './components/matting';
import NavItem from './components/nav-item';
import User from './components/user';
import { Spin } from '@gaoding/gdui';
import ToolsPopover from './components/tools-popover';
import { LOADING_HTML } from './utils/constant';
import { get } from 'lodash';
export default {
  name: 'editor-nav',
  components: {
    NavItem,
    DesignTemplate,
    Matting,
    Beautify,
    User,
    ToolsPopover
  },
  props: {
    // 设置整个容器的样式，为一个函数，函数的参数为fixed，当前的header是否已经fixed
    setStyle: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    // 函数参数为files，应当在改函数中上传图片并返回一个值为图片url的promise
    uploadFunc: {
      type: Function,
      required: true
    },
    // 用户session
    session: {
      type: Object,
      required: true
    },
    // 当前主页的路由
    homePath: {
      type: String,
      default: '/'
    },
    // 背景是否透明，透明背景在滚动的时候会变成白底黑字
    transparent: {
      type: Boolean,
      default: true
    }
  },

  data() {
    var transparent = this.transparent;
    return {
      fixed: !transparent,
      DesignTemplate
    };
  },

  mounted() {
    if (this.transparent) {
      var self = this;

      var listenerScroll = function listenerScroll() {
        var scrollTop = document.documentElement.scrollTop;
        self.fixed = scrollTop > 10;
      };

      window.addEventListener('scroll', listenerScroll, false);
      this.$once('hook:beforeDestroy', function () {
        window.removeEventListener('scroll', listenerScroll, false);
      });
    }
  },

  methods: {
    uploadFuncWidthLoading(files, urlPrefix) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newWindow, url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newWindow = window.open('about:blank', new Date().getTime());
                newWindow.document.write(LOADING_HTML);
                Spin.open({
                  tip: '图片上传中',
                  size: 'large'
                });
                _context.prev = 3;
                _context.next = 6;
                return _this.uploadFunc(files[0]);

              case 6:
                url = _context.sent;
                newWindow.location.href = urlPrefix + encodeURI(url);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                console.log(_context.t0);

              case 13:
                _context.prev = 13;
                Spin.close();
                return _context.finish(13);

              case 16:
                return _context.abrupt("return", url);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10, 13, 16]]);
      }))();
    },

    handleUpload(files) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.uploadFuncWidthLoading(files, 'https://www.gaoding.com/clip?url=');

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    setIconStyle(isHover) {
      var transparent = !this.fixed;
      return {
        fill: transparent ? 'white' : isHover ? '#2254f4' : '#7F8792',
        opacity: transparent ? isHover ? 1 : 0.8 : 1
      };
    },

    onExperience() {
      this.$emit('onExperience');
    },

    hanldeClick(e, params) {
      e.stopPropagation();
      var data = get(e, 'target.dataset');

      if (!data) {
        return;
      }

      var type = data.type;
      this.$emit('click', Object.assign({
        click_type: type
      }, params));
    }

  }
};
</script>
<style scoped>
.editor-nav {
  display: flex;
  height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  transition: all 0.2s ease;
  font-size: 14px;
}
.editor-nav-logo {
  margin-left: 24px;
  margin-right: 72px;
  cursor: pointer;
}
.editor-nav-left {
  flex: 2;
  display: flex;
  align-items: center;
}
.editor-nav-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.editor-nav-right .user {
  margin-right: 24px;
}

</style>
<style>
* {
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: subpixel-antialiased;
}
.nav__transparent {
  background-color: rgba(0, 0, 0, 0.03);
}
.nav__transparent .editor-nav-logo svg {
  fill: #ffffff;
}
.nav__transparent .gm-v3-header-user__text {
  color: white;
  opacity: 0.9;
}
.nav__transparent .gm-v3-header-user__text:hover {
  opacity: 1;
  font-weight: 700;
}
.nav__transparent .activeClass {
  opacity: 1 !important;
  font-weight: 700;
}
.nav__white {
  background-color: white;
  border-bottom: 1px solid #F6F7F9;
}
.nav__white .editor-nav-logo svg {
  fill: #33383e;
}
.nav__white .gm-v3-header-user__text {
  opacity: 0.9;
  color: #444950;
}
.nav__white .gm-v3-header-user__text:hover {
  opacity: 1;
  color: #2254f4;
  font-weight: 700;
}
.nav__white .activeClass {
  opacity: 1 !important;
  color: #2254f4 !important;
  font-weight: 700;
}

</style>
<style>
.editor-nav .g-popover {
  margin-top: 15px !important;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
}
.editor-nav-left .g-popover {
  margin-left: -36px;
}
.editor-nav-right-btn {
  border: 1px solid #2254F4;
  box-sizing: border-box;
  border-radius: 18px;
  width: 88px;
  color: #2254F4;
  font-weight: 700;
  font-size: 14px;
  padding: 7px 14px;
  margin-right: 24px;
  background-color: #ffffff00;
  cursor: pointer;
}
.editor-nav-right-btn:focus {
  outline: none;
}
.editor-nav-right-btn:hover {
  transition: background-color 0.2s;
  background: #2254F4;
  color: #FFFFFF;
}

</style>
